import {ConnectedComponent} from 'lowkey-component'
import {createNavState} from '@services/NavState'
import {navSelectors} from '@store/navSlice'

export class HeaderNavDisplay extends ConnectedComponent {
  private navState = createNavState()

  didMount() {
    this.observe(navSelectors.selectHeaderNavDisplayState, (state) => {
      switch (state) {
        case 'hide':
          this.element.classList.add('hide')
          this.element.classList.remove('show')
          return
        case 'show':
          this.element.classList.add('show')
          this.element.classList.remove('hide')
          return
        case undefined:
          this.element.classList.remove('hide')
          this.element.classList.remove('show')
          return
      }
    })

  }

}
